var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BookmarkModel } from 'src/app/bookmarks/models/bookmark.model';
import { Store, Select, Actions, ofActionDispatched } from '@ngxs/store';
import { SetPublishDimensions, GetPublishIFrame, GetPublishURL, GetPublishURLSuccess, GetPublishIFrameSuccess, GetPublishURLFail, GetPublishIFrameFail, SetPublishing, GetPublishImageCode, GetPublishImageCodeSuccess, GetPublishImageCodeFail, SavePublishImage, SavePublishImageSuccess, SavePublishImageFail } from '../../state/publish.actions';
import { PublishState } from '../../state/publish.state';
import { Observable, Subject, of } from 'rxjs';
import { WidgetOptions } from '../../models/widget-options.model';
import { FormBuilder, Validators } from '@angular/forms';
import { debounceTime, takeUntil, flatMap } from 'rxjs/operators';
import { OrganizationsState } from 'src/app/organizations/state/organizations.state';
import { PublishService } from '../../publish.service';
import { StorageService, StorageItemEnum } from 'src/app/shared/storage.service';
import { AuthState } from 'src/app/auth/state/auth/auth.state';
import { ClipboardService } from 'src/app/shared/clipboard.service';
import { DialogService } from 'src/app/dialogs/dialog.service';
import { PublishWidgetComponent } from '../publish-widget/publish-widget.component';
import { ImageTypeEnum } from 'src/app/shared/image.service';
import { BackgroundModel } from 'src/app/engine/models/background.model';
import { get } from 'lodash';
import { invalidateLocalWidgetOptions } from 'src/app/shared/storage-utils';
var snapshotSmall = {
    'title': 'Small',
    'type': 'desktop',
    'dimensions': {
        'width': 480,
        'height': 320
    },
    'orientation': 'horizontal'
};
var snapshotMedium = {
    'title': 'Medium',
    'type': 'desktop',
    'dimensions': {
        'width': 700,
        'height': 550
    },
    'orientation': 'horizontal'
};
var snapshotLarge = {
    'title': 'Large',
    'type': 'desktop',
    'dimensions': {
        'width': 1920,
        'height': 1200
    },
    'orientation': 'horizontal'
};
var snapshotMax = {
    'title': 'Maximum',
    'type': 'desktop',
    'dimensions': {
        'width': 2560,
        'height': 1440
    },
    'orientation': 'horizontal'
};
var PublishComponent = /** @class */ (function () {
    function PublishComponent(store, actions, publishService, storageService, clipboardService, dialogService, snackBar, fb, ref) {
        var _this = this;
        this.store = store;
        this.actions = actions;
        this.publishService = publishService;
        this.storageService = storageService;
        this.clipboardService = clipboardService;
        this.dialogService = dialogService;
        this.snackBar = snackBar;
        this.fb = fb;
        this.ref = ref;
        // snapshot state
        this.minSnapshotDimensions = {
            width: 300,
            height: 300
        };
        this.maxSnapshotDimensions = {
            width: 2560,
            height: 1440
        };
        this.snapshotSizes = [snapshotSmall, snapshotMedium, snapshotLarge, snapshotMax];
        this.selectedSnapshotSize = snapshotMedium;
        this.ngUnsubscribe = new Subject();
        // optional: default options
        this.defaultWidgetOptions = __assign({}, new WidgetOptions(), { loadRotate: 10 });
        var widgetOptions = this.getWidgetOptions();
        var dimensions = this.store.selectSnapshot(PublishState.getDimensions);
        var minDimensions = this.store.selectSnapshot(PublishState.getMinDimensions);
        var _a = widgetOptions.initial, button = _a.button, handHint = _a.handHint, play = _a.play;
        var _b = widgetOptions.disableScroll, alert = _b.alert, overlay = _b.overlay;
        // mode selection form
        this.formModeGroup = this.fb.group({
            mode: ['3d', Validators.required]
        });
        // snapshot form
        var snapshotDimensions = this.selectedSnapshotSize.dimensions;
        this.formSnapshot = this.fb.group({
            dimensions: this.fb.group({
                width: [
                    snapshotDimensions.width,
                    [Validators.required, Validators.min(this.minSnapshotDimensions.width), Validators.max(this.maxSnapshotDimensions.width)]
                ],
                height: [
                    snapshotDimensions.height,
                    [Validators.required, Validators.min(this.minSnapshotDimensions.height), Validators.max(this.maxSnapshotDimensions.height)]
                ]
            })
        });
        // widget 3D form
        this.form = this.fb.group({
            dimensions: this.fb.group({
                width: [dimensions.width, [Validators.min(minDimensions.width)]],
                height: [dimensions.height, [Validators.min(minDimensions.height)]]
            }),
            options: this.fb.group(widgetOptions),
            rotate: this.fb.group({
                enabled: widgetOptions.loadRotate !== null,
                value: widgetOptions.loadRotate
            }),
            initial: this.fb.group({
                enabled: button || handHint || play,
                mode: button ? 'button' : handHint ? 'handHint' ? play : 'play' : ''
            }),
            disableScroll: this.fb.group({
                enabled: alert || overlay,
                mode: alert ? 'alert' : (overlay ? 'overlay' : '')
            })
        });
        // set color
        var colors = get(widgetOptions, 'background.colors');
        if (colors) {
            var color = {
                red: colors[0],
                green: colors[1],
                blue: colors[2],
                alpha: colors.length > 3 ? colors[3] : 1
            };
            this.bgColor = this.getBackgroundFromColor(color);
        }
        // subscribe to url/code generation
        this.actions
            .pipe(ofActionDispatched(GetPublishURLSuccess), flatMap(function (response) { return _this.copyToClipboard(response.url); }), takeUntil(this.ngUnsubscribe))
            .subscribe(function (copied) {
            _this.snackBar.open(copied ? 'Successfully copied URL to clipboard.' : 'Unable to copy URL to clipboard.');
        });
        this.actions
            .pipe(ofActionDispatched(GetPublishURLFail), takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            _this.snackBar.open("Unable to generate URL.");
        });
        this.actions
            .pipe(ofActionDispatched(GetPublishIFrameSuccess), flatMap(function (response) { return _this.copyToClipboard(response.embed); }), takeUntil(this.ngUnsubscribe))
            .subscribe(function (copied) {
            _this.snackBar.open(copied ? 'Successfully copied embed code to clipboard.' : 'Unable to copy embed code to clipboard.');
        });
        this.actions
            .pipe(ofActionDispatched(GetPublishIFrameFail), takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            _this.snackBar.open("Unable to generate embed code.");
        });
        // generate image url
        this.actions
            .pipe(ofActionDispatched(SavePublishImageSuccess), flatMap(function (response) { return _this.copyToClipboard(response.imageURL); }), takeUntil(this.ngUnsubscribe))
            .subscribe(function (copied) {
            _this.snackBar.open(copied ? 'Successfully copied image URL to clipboard.' : 'Unable to copy image URL to clipboard.');
        });
        this.actions
            .pipe(ofActionDispatched(SavePublishImageFail), takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            _this.snackBar.open("Unable to generate image URL.");
        });
        // generate image code
        this.actions
            .pipe(ofActionDispatched(GetPublishImageCodeSuccess), flatMap(function (response) { return _this.copyToClipboard(response.embed); }), takeUntil(this.ngUnsubscribe))
            .subscribe(function (copied) {
            _this.snackBar.open(copied ? 'Successfully copied image embed code to clipboard.' : 'Unable to copy image embed code to clipboard.');
        });
        this.actions
            .pipe(ofActionDispatched(GetPublishImageCodeFail), takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            _this.snackBar.open("Unable to generate embed code.");
        });
    }
    Object.defineProperty(PublishComponent.prototype, "widgetOptions", {
        get: function () {
            return this.mode === '2d' ? null : this.form.value.options;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PublishComponent.prototype, "rotateEnabled", {
        get: function () {
            var rotate = this.form.get('rotate').value;
            return rotate.enabled;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PublishComponent.prototype, "mode", {
        get: function () {
            return this.formModeGroup.get('mode').value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PublishComponent.prototype, "widgetWidth", {
        get: function () {
            if (this.mode === '2d') {
                return this.selectedSnapshotSize.dimensions.width;
            }
            else {
                return this.store.selectSnapshot(PublishState.getDimensions).width;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PublishComponent.prototype, "widgetHeight", {
        get: function () {
            if (this.mode === '2d') {
                return this.selectedSnapshotSize.dimensions.height;
            }
            else {
                return this.store.selectSnapshot(PublishState.getDimensions).height;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PublishComponent.prototype, "widgetBGColor", {
        get: function () {
            if (this.mode === '2d') {
                return this.snapshotBGColor;
            }
            else {
                return this.bgColor;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PublishComponent.prototype, "widgetScalable", {
        get: function () {
            return this.mode === '2d';
        },
        enumerable: true,
        configurable: true
    });
    PublishComponent.prototype.ngOnInit = function () {
        this.setupWidgetForm();
        this.setupSnapshotForm();
        this.store.dispatch(new SetPublishing(true));
    };
    PublishComponent.prototype.ngOnDestroy = function () {
        this.store.dispatch(new SetPublishing(false));
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    PublishComponent.prototype.setupWidgetForm = function () {
        var _this = this;
        var optionsGroup = this.form.get('options');
        var dimensionsGroup = this.form.get('dimensions');
        var rotateGroup = this.form.get('rotate');
        var initialGroup = this.form.get('initial');
        var disableScrollGroup = this.form.get('disableScroll');
        // rotate params
        var rotateEnabledField = rotateGroup.get('enabled');
        var rotateValueField = rotateGroup.get('value');
        // set rotate defaults when toggling rotate enabled
        rotateEnabledField.valueChanges
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (enabled) {
            if (enabled) { // set default widget rotate
                var rotateValue = typeof (rotateValueField.value) === 'number' ? rotateValueField.value : _this.defaultWidgetOptions.loadRotate;
                rotateValueField.patchValue(rotateValue);
            }
            else { // reset widget rotate
                optionsGroup.patchValue({
                    loadRotate: null
                });
            }
        });
        // push rotate changes to widget options
        rotateValueField.valueChanges
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (value) {
            optionsGroup.patchValue({
                loadRotate: value
            });
        });
        // sync initial params
        initialGroup.get('enabled').valueChanges
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (enabled) {
            initialGroup.patchValue({
                mode: enabled ? 'button' : ''
            });
        });
        initialGroup.get('mode').valueChanges
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (mode) {
            initialGroup.patchValue({ enabled: !!mode }, { emitEvent: false });
            optionsGroup.patchValue({
                initial: {
                    button: mode === 'button',
                    handHint: mode === 'handHint',
                    play: mode === 'play'
                }
            });
        });
        // sync scroll params
        disableScrollGroup.get('enabled').valueChanges
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (enabled) {
            disableScrollGroup.patchValue({
                mode: enabled ? 'alert' : ''
            });
        });
        disableScrollGroup.get('mode').valueChanges
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (mode) {
            disableScrollGroup.patchValue({ enabled: !!mode }, { emitEvent: false });
            optionsGroup.patchValue({
                disableScroll: {
                    alert: mode === 'alert',
                    overlay: mode === 'overlay'
                }
            });
        });
        // sync dimensions
        dimensionsGroup.valueChanges
            .pipe(debounceTime(300), takeUntil(this.ngUnsubscribe))
            .subscribe(function (dimensions) {
            _this.setScreenDimensions(dimensions);
        });
        this.dimensions$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (dimensions) {
            dimensionsGroup.setValue(dimensions, { emitEvent: false });
        });
        optionsGroup.valueChanges
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (options) {
            // persist options
            _this.writeSavedOptions(options);
        });
    };
    PublishComponent.prototype.setupSnapshotForm = function () {
        var _this = this;
        var formSnapshotDimensions = this.formSnapshot.get('dimensions');
        formSnapshotDimensions.valueChanges
            .pipe(debounceTime(500), takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            // validation
            var _a = formSnapshotDimensions.value, width = _a.width, height = _a.height;
            if (formSnapshotDimensions.valid) {
                // find target dimensions or custom
                var foundSnap = _this.snapshotSizes.find(function (snap) { return snap.dimensions.width === width && snap.dimensions.height === height; });
                _this.selectedSnapshotSize = __assign({}, _this.selectedSnapshotSize, { title: foundSnap ? foundSnap.title : 'Custom', dimensions: {
                        width: width,
                        height: height
                    } });
                // mark changes
                _this.ref.markForCheck();
            }
        });
    };
    PublishComponent.prototype.setScreenDimensions = function (dimensions) {
        this.store.dispatch(new SetPublishDimensions(dimensions));
    };
    PublishComponent.prototype.handleGenerateIFrame = function () {
        this.generateIFrameCode();
    };
    PublishComponent.prototype.handleGenerateURL = function () {
        this.generateURL();
    };
    PublishComponent.prototype.handleCopyImageURL = function () {
        this.generateImageURL();
    };
    PublishComponent.prototype.handleGenerateImage = function () {
        this.generateImageCode();
    };
    PublishComponent.prototype.generateIFrameCode = function () {
        var widgetOptions = this.form.value.options;
        this.store.dispatch(new GetPublishIFrame(this.model, widgetOptions, this.camera));
    };
    PublishComponent.prototype.generateURL = function () {
        var widgetOptions = this.form.value.options;
        this.store.dispatch(new GetPublishURL(this.model, widgetOptions, this.camera));
    };
    PublishComponent.prototype.generateImageURL = function () {
        var _this = this;
        this.publishWidget.takeSnapshot()
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (imageData) {
            _this.store.dispatch(new SavePublishImage(imageData));
        });
    };
    PublishComponent.prototype.generateImageCode = function () {
        var _this = this;
        this.publishWidget.takeSnapshot()
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (imageData) {
            var widgetOptions = new WidgetOptions(); // use default options
            _this.store.dispatch(new GetPublishImageCode(_this.model, imageData, widgetOptions, _this.camera));
        });
    };
    PublishComponent.prototype.handleSnapshotBGColorClick = function (color) {
        this.snapshotBGColor = this.getBackgroundFromColor(color);
    };
    PublishComponent.prototype.handleSnapshotSizeClick = function (screen) {
        this.selectedSnapshotSize = __assign({}, screen);
        this.formSnapshot.patchValue({
            dimensions: __assign({}, screen.dimensions)
        });
    };
    PublishComponent.prototype.handleDownloadSnapClick = function () {
        var _this = this;
        this.publishWidget.takeSnapshot()
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (imageData) {
            _this.downloadImage(imageData);
        });
    };
    PublishComponent.prototype.handleCameraUpdated = function (camera) {
        this.camera = camera;
    };
    PublishComponent.prototype.copyToClipboard = function (copyText) {
        var _this = this;
        return this.clipboardService.copyToClipboard(copyText)
            .pipe(flatMap(function (copied) {
            if (copied) {
                return of(copied);
            }
            else {
                return _this.dialogService.openClipboardDialog(copyText)
                    .afterClosed();
            }
        }));
    };
    PublishComponent.prototype.formatScreenSizeText = function (screen) {
        var title = screen.title, dimensions = screen.dimensions;
        return title + " (" + dimensions.width + " x " + dimensions.height + ")";
    };
    PublishComponent.prototype.getBackgroundFromColor = function (color) {
        var colors = color ? [color.red, color.green, color.blue, color.alpha] : null;
        if (colors) {
            return new BackgroundModel(__spread(colors, colors), 'radial', [0, 100]);
        }
        else {
            return null;
        }
    };
    PublishComponent.prototype.getWidgetOptions = function () {
        // read persisted options
        var storedOptions = this.readSavedOptions();
        // read organization settings
        var orgWidgetOptions = this.store.selectSnapshot(OrganizationsState.getWidgetOptions);
        // apply saved settings
        if (storedOptions) {
            var userOptions = this.publishService.extendWidgetOptions(new WidgetOptions(), storedOptions);
            return __assign({}, userOptions, { 
                // !important: disable user background, expect from organization
                background: orgWidgetOptions ? orgWidgetOptions.background : null });
        }
        else {
            return orgWidgetOptions || new WidgetOptions();
        }
    };
    PublishComponent.prototype.readSavedOptions = function () {
        // invalidate widget options in local storage created before 
        // Wed Nov 13 2019 14:57:47 GMT-0500 (Eastern Standard Time)
        var invalidateBefore = 1573675067505;
        var userProfileId = this.getStorageKey();
        invalidateLocalWidgetOptions(userProfileId, invalidateBefore);
        // read persisted options
        var storedOptions = this.storageService.getLocalJSON(StorageItemEnum.WidgetOptions);
        if (storedOptions) {
            var key = this.getStorageKey();
            return storedOptions[key];
        }
        else {
            return null;
        }
    };
    PublishComponent.prototype.writeSavedOptions = function (options) {
        // patch options with a timestamp
        var optionsWithTimestamp = __assign({}, options, { timestamp: Date.now() });
        // modify existing entry
        var storedOptions = this.storageService.getLocalJSON(StorageItemEnum.WidgetOptions) || {};
        var key = this.getStorageKey();
        storedOptions[key] = optionsWithTimestamp;
        this.storageService.setLocalItem(StorageItemEnum.WidgetOptions, storedOptions);
    };
    // get unique key for widget settings
    PublishComponent.prototype.getStorageKey = function () {
        return this.store.selectSnapshot(AuthState.getUserProfile).eid;
    };
    PublishComponent.prototype.downloadImage = function (imageData) {
        var _this = this;
        var title = this.model.title || 'snapshot';
        var normalizedTitle = title.replace(/ /g, '_').replace(/\W/g, '');
        var fileName = normalizedTitle + ".jpeg";
        this.publishService.exportImage(imageData, ImageTypeEnum.JPEG, fileName)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (success) {
            _this.snackBar.open(success ? "Successfuly download image" : "Unable to download image.");
        });
    };
    __decorate([
        Select(PublishState.getDimensions),
        __metadata("design:type", Observable)
    ], PublishComponent.prototype, "dimensions$", void 0);
    __decorate([
        Select(PublishState.getMinDimensions),
        __metadata("design:type", Observable)
    ], PublishComponent.prototype, "minDimensions$", void 0);
    return PublishComponent;
}());
export { PublishComponent };
